<template>
  <div>
    <nav-bar v-if="showNav" :dark="isDarkMode" />
    <v-container fluid ma-0 pa-0>
      <slot />
    </v-container>
    <LogoFooter v-if="showFooter" />
  </div>
</template>

<script>
const LogoFooter = () => import('@/components/Footers/LogoFooter.vue');
const NavBar = () => import('@/components/Navbars/NavBar.vue');

export default {
  components: {
    LogoFooter,
    NavBar,
  },
  data() {
    return {};
  },
  computed: {
    isDarkMode() {
      return this.$route.meta.mode === 'dark';
    },
    showNav() {
      return !this.$route.meta.hideNav;
    },
    showFooter() {
      return !this.$route.meta.hideFooter;
    },
  },
};
</script>
